var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"doclib-footer-dialog",on:{"click":_vm.closeFooterDialog}},[_c('div',{staticClass:"content-dialog",on:{"click":_vm.clickContentDialog}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }